const routers = [
  {
    path: "/",
    component: () => import("@/pages/login/index"),
    meta: {
      title: "登陆"
    }
  },
  {
    path: "/index",
    component: () => import("@/pages/index/index"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/pages/home/index"),
        meta: {
          title: "首页"
        }
      },
      {
        path: "/member_center/memberList",
        name: "memberList",
        component: () => import("@/pages/member_center/index"),
        meta: {
          title: "会员列表"
        }
      },
      {
        path: "/goods_center/goodsList",
        name: "goodsList",
        component: () => import("@/pages/goods_center/index"),
        meta: {
          title: "商品列表"
        }
      },

      {
        path: "/goods_center/product",
        name: "product",
        component: () => import("@/pages/goods_center/product/index"),
        meta: {
          title: "产品管理"
        }
      },

      {
        path: "/order_center/orderList",
        name: "orderList",
        component: () => import("@/pages/order_center/index"),
        meta: {
          title: "订单列表"
        }
      },

      {
        path: "/marketing_center/salesPromotion",
        name: "salesPromotion",
        component: () =>
          import("@/pages/marketing_center/sales_promotion/index"),
        meta: {
          title: "促活"
        }
      },

      {
        path: "/marketing_center/pullNew",
        name: "pullNew",
        component: () => import("@/pages/marketing_center/pull_new/index"),
        meta: {
          title: "拉新"
        }
      },

      {
        path: "/marketing_center/quiz",
        name: "quiz",
        component: () => import("@/pages/marketing_center/quiz/index"),
        meta: {
          title: "有奖竞猜"
        }
      },

      {
        path: "/content_center/information",
        name: "information",
        component: () => import("@/pages/content_center/information/index"),
        meta: {
          title: "文章管理"
        }
      },

      {
        path: "/content_center/informationClass",
        name: "informationClass",
        component: () =>
          import("@/pages/content_center/information_class/index"),
        meta: {
          title: "栏目管理"
        }
      },
      {
        path: "/content_center/material",
        name: "material",
        component: () => import("@/pages/content_center/material/index"),
        meta: {
          title: "素材管理"
        }
      },

      {
        path: "/report_center/memberAnalysisReport",
        name: "memberAnalysisReport",
        component: () => import("@/pages/report_center/index"),
        meta: {
          title: "会员分析报表"
        }
      },

      {
        path: "/report_center/logistics",
        name: "logistics",
        component: () => import("@/pages/report_center/logistics/index"),
        meta: {
          title: "物流查询"
        }
      },

      {
        path: "/report_center/stock",
        name: "stock",
        component: () => import("@/pages/report_center/stock/index"),
        meta: {
          title: "库存统计"
        }
      },

      {
        path: "/report_center/alesInventoryExport",
        name: "alesInventoryExport",
        component: () => import("@/pages/report_center/alesInventoryExport/index"),
        meta: {
          title: "进销存数据导出"
        }
      },

      {
        path: "/report_center/fleeing_goods",
        name: "fleeing_goods",
        component: () => import("@/pages/report_center/fleeing_goods/index"),
        meta: {
          title: "窜货统计"
        }
      },
      {
        path: "/report_center/month_shipment",
        name: "month_shipment",
        component: () => import("@/pages/report_center/month_shipment/index"),
        meta: {
          title: "月出货量"
        }
      },
      {
        path: "/report_center/product_type_AF/single",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/single/index"),
        meta: {
          title: "单个机构进货月度排名表AF"
        }
      },
      {
        path: "/report_center/product_type_AF/sale_total",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/sale_total/index"),
        meta: {
          title: "大区纯销数据汇总AF"
        }
      },
      {
        path: "/report_center/product_type_AF/region",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/region/index"),
        meta: {
          title: "区域机构月度进货统计表AF"
        }
      },
      {
        path: "/report_center/product_type_AF/group",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/group/index"),
        meta: {
          title: "集团机构进货月度排名表AF"
        }
      },
      {
        path: "/report_center/product_type_AF/common_size",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/common_size/index"),
        meta: {
          title: "大区纯销数据同比分析AF"
        }
      },
      {
        path: "/report_center/product_type_AF/chain",
        name: "product_type_AF",
        component: () =>
          import("@/pages/report_center/product_type_AF/chain/index"),
        meta: {
          title: "大区纯销数据环比分析AF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/chain",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/chain/index"),
        meta: {
          title: "大区纯销数据环比分析NCTF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/common_size",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/common_size/index"),
        meta: {
          title: "大区纯销数据同比分析NCTF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/group",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/group/index"),
        meta: {
          title: "集团机构进货月度排名表NCTF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/region",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/region/index"),
        meta: {
          title: "区域机构月度进货统计表NCTF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/sale_total",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/sale_total/index"),
        meta: {
          title: "大区纯销数据汇总NCTF"
        }
      },
      {
        path: "/report_center/product_type_NCTF/single",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_NCTF/single/index"),
        meta: {
          title: "单个机构进货月度排名表NCTF"
        }
      },
      {
        path: "/report_center/product_type_SP/single",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_SP/single/index"),
        meta: {
          title: "单个机构进货月度排名表SP"
        }
      },
      {
        path: "/report_center/product_type_SP/SP",
        name: "product_type_NCTF",
        component: () =>
          import("@/pages/report_center/product_type_SP/SP/index"),
        meta: {
          title: "SP产品进货月度统计"
        }
      },
      {
        path: "/rule_management/integral/integralAdjustment",
        name: "integralAdjustment",
        component: () =>
          import("@/pages/rule_management/integral/integral_adjustment/index"),
        meta: {
          title: "积分调整"
        }
      },

      {
        path: "/rule_management/integral/integralRule",
        name: "integralRule",
        component: () =>
          import("@/pages/rule_management/integral/integral_rule/index"),
        meta: {
          title: "积分规则"
        }
      },

      {
        path: "/rule_management/level",
        name: "level",
        component: () => import("@/pages/rule_management/level/index"),
        meta: {
          title: "等级管理"
        }
      },
      {
        path: "/sales_management/actual_sales",
        name: "actualSales",
        component: () => import("@/pages/sales_management/actual_sales/index"),
        meta: {
          title: "实销数据管理"
        }
      },
      {
        path: "/sales_management/organ",
        name: "organ",
        component: () => import("@/pages/sales_management/organ/index"),
        meta: {
          title: "机构信息管理"
        }
      },
      {
        path: "/IM_warehousing/HQ_IM_scan",
        name: "HQ_IM_scan",
        component: () =>
          import(
            "@/pages/warehouse_management/IM_warehousing/HQ_IM_scan/index"
          ),
        meta: {
          title: "总部入库扫描管理"
        }
      },
      {
        path: "/HQ_IM_scan/add_IM_scan",
        name: "add_IM_scan",
        component: () =>
          import(
            "@/pages/warehouse_management/IM_warehousing/HQ_IM_scan/add_IM_scan/index"
          ),
        meta: {
          title: "新增入库扫描"
        }
      },
      {
        path: "/IM_warehousing/subordinate_salesReturn",
        name: "subordinate_salesReturn",
        component: () =>
          import(
            "@/pages/warehouse_management/IM_warehousing/subordinate_salesReturn/index"
          ),
        meta: {
          title: "下级退货确认入库"
        }
      },
      {
        path: "/IM_warehousing/add_superior",
        name: "add_superior",
        component: () =>
          import(
            "@/pages/warehouse_management/IM_warehousing/add_superior/index"
          ),
        meta: {
          title: "上级出货确认入库"
        }
      },
      {
        path: "/EX_warehouse/goods_Ex_scan",
        name: "goods_Ex_scan",
        component: () =>
          import(
            "@/pages/warehouse_management/EX_warehouse/goods_Ex_scan/index"
          ),
        meta: {
          title: "产品出货扫描管理"
        }
      },
      {
        path: "/goods_Ex_scan/add_EX_scan",
        name: "add_EX_scan",
        component: () =>
          import(
            "@/pages/warehouse_management/EX_warehouse/goods_Ex_scan/add_EX_scan/index"
          ),
        meta: {
          title: "新增出货扫描"
        }
      },
      {
        path: "/EX_warehouse/add_goods_return",
        name: "add_goods_return",
        component: () =>
          import(
            "@/pages/warehouse_management/EX_warehouse/add_goods_return/index"
          ),
        meta: {
          title: "产品退货扫描管理"
        }
      },
      {
        path: "/add_goods_return/add_return_scan",
        name: "add_return_scan",
        component: () =>
          import(
            "@/pages/warehouse_management/EX_warehouse/add_goods_return/add_return_scan/index"
          ),
        meta: {
          title: "新增退货扫描"
        }
      },
      {
        path: "/dealers_management/dealers_data",
        name: "dealers_data",
        component: () =>
          import("@/pages/warehouse_management/dealers_management/index"),
        meta: {
          title: "经销商资料"
        }
      },
      {
        path: "/dealers_data/dealer_update",
        name: "dealer_update",
        component: () =>
          import(
            "@/pages/warehouse_management/dealers_management/dealer_update/index"
          ),
        meta: {
          title: "经销商资料查看/编辑"
        }
      },
      {
        path: "/air_academy/memberList",
        name: "memberList",
        component: () =>
          import("@/pages/air_academy/member_center/member/index"),
        meta: {
          title: "学员列表"
        }
      },
      {
        path: "/air_academy/medical",
        name: "medical",
        component: () =>
          import("@/pages/air_academy/member_center/medical/index"),
        meta: {
          title: "医学苑审核"
        }
      },
      {
        path: "/air_academy/business",
        name: "business",
        component: () =>
          import("@/pages/air_academy/member_center/business/index"),
        meta: {
          title: "商学苑审核"
        }
      },
      {
        path: "/air_academy/staff",
        name: "staff",
        component: () =>
          import("@/pages/air_academy/member_center/staff/index"),
        meta: {
          title: "员工审核"
        }
      },
      {
        path: "/air_academy/banner",
        name: "banner",
        component: () =>
          import("@/pages/air_academy/content_center/banner/index"),
        meta: {
          title: "banner管理"
        }
      },

      {
        path: "/air_academy/popup",
        name: "popup",
        component: () =>
          import("@/pages/air_academy/content_center/popup/index"),
        meta: {
          title: "弹窗管理"
        }
      },
      {
        path: "/air_academy/msgpush",
        name: "msgpush",
        component: () =>
          import("@/pages/air_academy/content_center/msgpush/index"),
        meta: {
          title: "公众号消息推送"
        }
      },
      {
        path: "/air_academy/album",
        name: "album",
        component: () =>
          import("@/pages/air_academy/content_center/album/index"),
        meta: {
          title: "假期专辑活动"
        }
      },

      {
        path: "/air_academy/creditrule",
        name: "creditrule",
        component: () =>
          import("@/pages/air_academy/credit_manager/creditrule/index"),
        meta: {
          title: "学分规则"
        }
      },
      {
        path: "/air_academy/creditadjustment",
        name: "creditadjustment",
        component: () =>
          import("@/pages/air_academy/credit_manager/creditadjustment/index"),
        meta: {
          title: "学分调整"
        }
      },
      {
        path: "/air_academy/catalog",
        name: "catalog",
        component: () => import("@/pages/air_academy/catalog/index"),
        meta: {
          title: "分类列表"
        }
      },
      {
        path: "/air_academy/teacher",
        name: "catalog",
        component: () => import("@/pages/air_academy/teacher/index"),
        meta: {
          title: "讲师列表"
        }
      },
      {
        path: "/air_academy/course",
        name: "course",
        component: () => import("@/pages/air_academy/course/index"),
        meta: {
          title: "课程列表"
        }
      },
      {
        path: "/air_academy/popularCourse/hotCoures",
        name: "popularCourse",
        component: () => import("@/pages/air_academy/popularCourse/hotCoures/index"),
        meta: {
          title: "医学院热门课程"
        }
      },
      {
        path: "/air_academy/popularCourse/newCoures",
        name: "popularCourse",
        component: () => import("@/pages/air_academy/popularCourse/newCoures/index"),
        meta: {
          title: "商学院热门课程"
        }
      },
      {
        path: "/air_academy/popularCourse/competitionCoures",
        name: "popularCourse",
        component: () => import("@/pages/air_academy/popularCourse/competitionCoures/index"),
        meta: {
          title: "赛事热门课程"
        }
      },
      {
        path: "/air_academy/popularCourse/brandCoures",
        name: "popularCourse",
        component: () => import("@/pages/air_academy/popularCourse/brandCoures/index"),
        meta: {
          title: "品牌热门课程"
        }
      },
      {
        path: "/air_academy/liveCourse",
        name: "liveCourse",
        component: () => import("@/pages/air_academy/liveCourse/index"),
        meta: {
          title: "直播课程统计"
        }
      }
    ]
  }
];
export default routers;



// WEBPACK FOOTER //
// ./src/router/routers.js